import {cookieNames, getCookie, setCookie} from "../common/services/cookies.service";
import {envUrls} from "../../constants";
import {initializeWalkmeCookies} from "../common/services/api.service";

const WALKME_SCRIPT_ID = 'TS_WalkMe_Script';
const WALKME_COOKIE_NAME = 'Enable_Walkme';

enum walkMeKeys {
    PROD = 'https://eu-cdn.walkme.com/users/0090debf1f6a4b4da10a010e4a786a56/walkme_0090debf1f6a4b4da10a010e4a786a56_https.js',
    TRN = 'https://eu-cdn.walkme.com/users/0090debf1f6a4b4da10a010e4a786a56/trn/walkme_0090debf1f6a4b4da10a010e4a786a56_https.js',
}

export type WalkMeConfig = {
    baseUrl?: string;
}

function loadWalkMeScripts(config: WalkMeConfig) {
    const enableWalkMe = getCookie(WALKME_COOKIE_NAME);
    const walkMeScriptElement = document.getElementById(WALKME_SCRIPT_ID);
    if (enableWalkMe?.toLowerCase() !== 'true' || walkMeScriptElement) {
        return;
    }
    let walkMeSrc;
    switch (config.baseUrl ?? envUrls.TRN) {
        case envUrls.PROD:
        case envUrls.PROD_TS: {
            walkMeSrc = walkMeKeys.PROD;
            break;
        }
        case envUrls.TRN:
        case envUrls.TRN_ALIAS_TS:
        case envUrls.TRN_TS: {
            walkMeSrc = walkMeKeys.TRN;
            break;
        }
    }
    if (walkMeSrc) {
        let walkMeScript = document.createElement('script');
        walkMeScript.type = 'text/javascript';
        walkMeScript.async = true;
        walkMeScript.id = WALKME_SCRIPT_ID;
        walkMeScript.src = walkMeSrc;
        let firstScript = document.getElementsByTagName('script')[0];
        firstScript.parentNode?.insertBefore(walkMeScript, firstScript);
        window._walkmeConfig = { smartLoad: true };
    } else {
        // eslint-disable-next-line no-console
        console.log('Looks like there is something wrong with walkMe baseUrl.');
    }
}

function unloadWalkMeScripts() {
    window._walkMe?.removeWalkMe?.();
}
function initWalkMe(config: WalkMeConfig) {
    const enableWalkMe = getCookie(WALKME_COOKIE_NAME);
    //no cookie is present => need to fetch from TIM
    if (!enableWalkMe || enableWalkMe === "") {
        initializeWalkmeCookies(config.baseUrl ?? envUrls.TRN, null, () => {
            loadWalkMeScripts(config);
        }, () => 0);
    }
    //cookie is present, just check it
    else
        loadWalkMeScripts(config);
}

export const setWalkMeTemplateId = (templateId: number|undefined) => {
    const enableWalkMe = getCookie(WALKME_COOKIE_NAME);
    if (enableWalkMe?.toLowerCase() === 'true') {
        /* break the url into individual parts:
           e.g: projects.tolunastart.com will turn into [projects, tolunastart, com]
         */
        const domainParts = window.location.hostname.split(".");
        /*
          meaning, start counting backwards and slice:
          e.g: only take tolunastart and com and joing them into tolunastart.com
         */
        const domain = domainParts.slice(-2).join(".");
        setCookie(cookieNames.WALKME_SOLUTION_ID, templateId, 1, domain);
    }
};

export const CUSTOM_SURVEY_ID = 1;

export default {
    init: initWalkMe,
    destroy: unloadWalkMeScripts,
    setWalkMeTemplateId: setWalkMeTemplateId,
    CUSTOM_SURVEY_ID
};
